import { CustomHttpClient } from './../../providers/CustomHttpClient';
import { environment } from '../../../environments/environment.prod'
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedeCredenciadaService {

  constructor(
    private http: CustomHttpClient,
  ) { }

  OnObterEstado() {
    return this.http.Get(`api/State/`);
  }

  OnObterCidades(idState) {
    return this.http.Get(`api/city/GetByState/${idState}`);
  }

  OnObterBairro(is_pln, city) {
    return this.http.Get(`/api/store/neighborhoods/${is_pln}/${city}`);
  }

  OnObterRedeCredenciada(is_pln, city, neighborhood, category?: string) {
    const query = category ? `?category=${encodeURIComponent(category)}` : '';
    return this.http.Get(`/api/store/neighborhoods/${is_pln}/${city}/${neighborhood}${query}`);
  }

  /** Diz se o plano exibe filtro e badge de produto na tela de Rede Credenciada. */
  OnExibeProduto(is_pln) {
    return this.http.Get(`/api/store/productcategory/${is_pln}`);
  }

}
